module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Kitchen1-0bfbe1c28675e1d12ab816519768fc92.jpg";